import { Box } from "@mui/material";
import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import authorityUserType from "../../assets/data/TkAuthorityProperty";
import TkButton from "../../components/atoms/TkButton";
import TkInfoManual from "../../components/atoms/TkInfoManual";
import TkStepper from "../../components/atoms/TkStepper";
import TkTable from "../../components/atoms/TkTable";
import TkContractorAndNumberLine from "../../components/molecules/TkContractorAndNumberLine";
import { BusinessContext } from "../../context/businessContext";
import { GlobalContext } from "../../context/globalContext";
import { RearrangementList } from "../../type/apiType/IAPI_STA027";
import "./_style.scss";
import { httpAPI_STA027 } from "./api/request";
import { infoHeadTitleList, infoManual, stepper } from "./parts";

/**
 * SCRC060105 職員一覧　配置換え確認
 * @return SCRC060105 職員一覧　配置換え確認
 */
const SCRC060105 = () => {
  const navigate = useNavigate();
  const { state: globalState, setState } = useContext(GlobalContext);
  const { state: businessState, setState: setBusinessState } =
    useContext(BusinessContext);
  const [infoBodyList, setInfoBodyList] = useState<any[]>([]);
  const [rearrangementList, setRearrangementList] = useState<
    RearrangementList[]
  >([]);
  const isKiko =
    globalState.authInfo?.userType === authorityUserType.userTypeNumber.KIKO;
  function openingScreen() {
    const staffList = businessState.job_27?.removeStaffList;
    const bodyList: any[] = [];
    const makeStaffList: any[] = [];
    staffList &&
      staffList.length > 0 &&
      staffList.forEach((staff) => {
        const data = [
          {
            children: (staff.staffNo ?? "") + ":" + (staff.staffName ?? ""),
          },
          {
            children:
              (staff.facilityNo ?? "") +
              ":" +
              (staff.facilityNo?.toString() === "999"
                ? "契約対象外施設"
                : staff.facilityName ?? ""),
          },
          {
            children:
              (staff.removeFacilityNo ?? "") +
              ":" +
              (staff.removeFacilityName?.toString() === "999"
                ? "契約対象外施設"
                : staff.removeFacilityName ?? ""),
          },
          {
            children: staff.removeDate,
            className: "center-align",
          },
        ];
        bodyList.push(data);
        const requestList: RearrangementList = {
          staffNo: staff.staffNo,
          bFacilityNo: staff.facilityNo,
          aFacilityNo: staff.removeFacilityNo,
          transferDate: staff.removeDate,
          updateDateTime: staff.updateDateTime,
        };
        makeStaffList.push(requestList);
      });
    setInfoBodyList(bodyList);
    setRearrangementList(makeStaffList);
  }

  useEffect(() => {
    openingScreen();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const okClick = async () => {
    // 法人職員異動更新API 呼び出し
    try {
      const res = await httpAPI_STA027({
        contractorNo: isKiko
          ? businessState.common?.contractorNo
          : globalState.authInfo?.contractorNo!,
        rearrangementList: rearrangementList,
        screenId: "SCRC060105",
      });
      if (res.resultCd === "I0000") {
        //3.申請id(対象外異動) または 3.申請id(復帰)に値が設定されている場合
        setState({
          ...globalState,
          errorMsgId: "",
        });
        if (res?.applyIdNotApplicable || res?.applyIdReturn) {
          setBusinessState({
            ...businessState,
            job_27: {
              ...businessState.job_27,
              applyIdNotApplicable: res?.applyIdNotApplicable,
              applyIdReturn: res?.applyIdReturn,
              continuousRemoveFacilityFlag: true,
            },
          });
          navigate("/SCRC060013");
        } else {
          setBusinessState({
            ...businessState,
            job_27: {
              ...businessState.job_27,
              facilityNo: rearrangementList[0]?.bFacilityNo,
              removeStaffList: []
            },
          });
          navigate("/SCRC060103");
        }
      } else {
        setState({
          ...globalState,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  };
  const cancelClick = () => {
    navigate("/SCRC060103");
  };
  return (
    <Box data-testid="SCRC060105PageForTest" className="tkSCRC060105">
      <TkStepper steps={stepper} activeStep={1} savaStep={1} />
      <TkInfoManual children={infoManual} rule={"\\n"} />
      {isKiko && (
        <TkContractorAndNumberLine
          name={"契約者(法人)名"}
          no={
            businessState.common?.contractorNo +
            ":" +
            businessState.common?.contractorName
          }
        />
      )}
      <TkTable headList={infoHeadTitleList} bodyList={infoBodyList} />
      <Box className="tkDisplay">
        <Box className="tkSpace">
          <TkButton onClick={cancelClick}>{"いいえ"}</TkButton>
        </Box>
        <Box className="tkSpace">
          <TkButton onClick={okClick}>{"はい"}</TkButton>
        </Box>
      </Box>
    </Box>
  );
};

export default SCRC060105;
